import { algo, PBKDF2, WordArray } from 'crypto-js';

import { CryptoHelper } from './crypto-helper';

/**
 * PBKDF2 function (pssword-based key derivation function)
 * @param input
 * @param salt
 * @iterations
 * @param keySize number of 32 bit words
 */
export function pbkdf2(
  input: Uint8Array | string,
  salt: Uint8Array | string,
  iterations: number,
  keySize?: number,
): Uint8Array {
  const wordInput = CryptoHelper.sanitizeInput(input);
  const wordSalt = CryptoHelper.sanitizeInput(salt);
  const options = {
    iterations,
    keySize,
    hasher: algo.SHA256,
  };
  if (options.keySize === undefined) {
    delete options.keySize;
  }
  const hash: WordArray = PBKDF2(wordInput, wordSalt, options);
  return CryptoHelper.wordArrayToByteArray(hash);
}
